import React, {Fragment, useContext, useEffect} from 'react';
import {Typography, List, ListItem, ListItemText} from '@material-ui/core';
import AffinityInfoContext from "../../../../../context/AffinityContext";
import useStyles from "./styles";

function CotizacionSuccess(props) {
    const classes = useStyles();
    const {cotizacionResponse} = props;
    const {coberturasInfo, coveragesToFilter} = useContext(AffinityInfoContext);

    function currencyFormat(numString) {
        numString = numString.toString().replace(/\./g, "")
        numString = numString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return numString
    }

    useEffect(() => {
        cotizacionResponse['detalleCoberturas']["obligatorias"].sort((a, b) => parseInt(a.numeroCobertura) - parseInt(b.numeroCobertura));
        cotizacionResponse['detalleCoberturas']["adicionales"].sort((a, b) => parseInt(a.numeroCobertura) - parseInt(b.numeroCobertura));
    }, []);

    return (
        <React.Fragment>
            <Fragment>
                <Typography variant="h5" gutterBottom style={{fontFamily: 'EncodeSansBold'}}>
                    Resumen de Cotización
                </Typography>
                <Typography gutterBottom style={{fontFamily: 'EncodeSansRegular'}}>
                    Cuota Mensual: ${cotizacionResponse['premioMensual'].toFixed(2)}
                </Typography>
                <Typography gutterBottom style={{fontFamily: 'EncodeSansRegular'}}>
                    Detalle Coberturas:
                </Typography>
                <List dense>
                    {cotizacionResponse['detalleCoberturas']["obligatorias"]
                        .filter(cob => !coveragesToFilter.includes(cob.numeroCobertura))
                        .map((item, index) => (
                        <ListItem key={index}>
                            <ListItemText
                                primary={coberturasInfo[item.numeroCobertura].descripcion}
                                secondary={`Suma Asegurada: $ ${currencyFormat(item.sumaAsegurada)}`}
                            />
                        </ListItem>
                    ))}
                </List>
                <Typography variant="subtitle1" gutterBottom style={{
                    fontFamily: 'Nunito',
                    display: cotizacionResponse['detalleCoberturas']["adicionales"].length === 0 && "none"
                }}>
                    Adicionales:
                </Typography>
                <List dense>
                    {cotizacionResponse['detalleCoberturas']["adicionales"].map((item, index) => (
                        <ListItem key={index}>
                            <ListItemText
                                primary={coberturasInfo[item.numeroCobertura].descripcion}
                                secondary={`Suma Asegurada: $ ${currencyFormat(item.sumaAsegurada)}`}
                            />
                        </ListItem>
                    ))}
                </List>
                <p className={classes.note}>*La aseguradora indemnizará los daños hasta las sumas aseguradas
                    contratadas</p>
            </Fragment>
        </React.Fragment>
    );
}

export default CotizacionSuccess;
